"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JUDGE_CALIBRATION_SCORE_MAX = exports.JUDGE_CALIBRATION_SCORE_MIN = exports.HUMAN_HYPOTHESIS_SCORE_KEY = exports.HUMAN_REVIEW_SCORE_KEY = exports.JUDGE_CALIBRATION_QUEUE_ID = void 0;
exports.JUDGE_CALIBRATION_QUEUE_ID = '44785394-286c-4619-9521-8d78c35b159c';
exports.HUMAN_REVIEW_SCORE_KEY = 'human_review_score';
exports.HUMAN_HYPOTHESIS_SCORE_KEY = 'human_hypothesis_score';
exports.JUDGE_CALIBRATION_SCORE_MIN = 1;
exports.JUDGE_CALIBRATION_SCORE_MAX = 10;
